// The Halloween weekend, as the viewer sees it (the town's switch is sim-server/src/world/Halloween.js).
//
// The town says whether it is on with the environment it sends (environment.halloween), so HALLOWEEN=off on the
// town puts the pumpkins away for every viewer at once. The viewer also keeps the end for itself: a tab that has lost
// the town, or a page opened on Monday before the town has answered, never shows them past midnight on Sunday.

export const HALLOWEEN_UNTIL = Date.parse('2026-11-02T00:00:00Z')

export function halloweenShown(environment, now = Date.now()) {
  return environment?.halloween === true && now < HALLOWEEN_UNTIL
}
